export const getLastOrderTotalUuid = (state) => {
  return state.VNOrderTotal.getIn(['lastOrderTotalAdditionalInfo', 'lastUuid'])
}

export const getLastOrderTotaMenulUuid = (state) => {
  return state.VNOrderTotal.getIn(['lastOrderTotalAdditionalInfo', 'lastMenuUuid'])
}
